const QRCode = require('qrcode')
import { smosterPlayerUrl } from '../util/endpointConfig'

export default async function generateQrCode(smosterId) {
  const res = await QRCode.toString(`${smosterPlayerUrl}?id=${smosterId}`)
  return res
}
